import React from 'react'
import { graphql, withApollo } from 'react-apollo'

import eventProducts from '~/App/graphql/queries/eventProducts.gql'
import { List, Button, Tag, Avatar } from 'antd'
import { inject, observer } from 'mobx-react'
import orderRegistrationFragment from '~/App/graphql/fragments/orderRegistration.gql'
import withProps from 'recompose/withProps'
import _get from 'lodash/get'
import { FormattedNumber } from 'react-intl'
import localeGet from '~/App/utils/localeGet';

@withApollo
@withProps(({ client, registrationId }) => {
  const registration = client.readFragment({
    id: `Registration:${registrationId}`,
    fragment: orderRegistrationFragment
  })
  return {
    registration
  }
})
@graphql(eventProducts, {
  options: ({ registration }) => ({
    variables: ({
      eventId: registration.eventId
    })
  })
})
@inject('i18n')
@inject('router')
@observer
class ProductExtraSale extends React.Component {
  handleSelectProduct = (productId) => {
    const { location } = this.props.router
    location.query = {
      ...location.query,
      pdId: productId
    }
  }

  onCancel = () => {
    const { location } = this.props.router
    const { pdId, ...query } = location.query
    location.query = query
  }

  render () {
    const { data, i18n: { locale }, registration } = this.props
    const { orderItems = [] } = registration
    if (data.loading) {
      return <div>Loading</div>
    }
    if (data.error) {
      return <div>Error</div>
    }
    const products = _get(data, 'products', []).filter(p=> !p.hidden && p.extraSale)
    return <div>
      <List
        itemLayout="vertical"
        dataSource={products}
        renderItem={(product, index) => {
          const selectedItems = orderItems.filter(item => item.productId === product._id).reduce((sum, item) => sum + item.quantity, 0)
          const productMaxItems = _get(product, 'maxItemsPerRegistration', 0)
          const selectDisabled = (selectedItems > 0 && productMaxItems > 0) && (selectedItems >= productMaxItems)
          const actions = [
            <Button icon="shopping-cart" disabled={selectDisabled} onClick={() => this.handleSelectProduct(product._id)}>{{ en: 'Select Product', zh: 'Select Product', th: 'เลือกสินค้า' }[locale]}</Button>,
            ...(selectDisabled ? [<span>{{ en: `Limited to ${productMaxItems} / 1 registration`, zh: `Limited to ${productMaxItems} / 1 registration`, th: `จำกัด ${productMaxItems} ชิ้น / 1 ใบสมัครเท่านั้น` }[locale]}</span>] : [])
          ]
          return <List.Item
            key={product._id}
            actions={actions}
            extra={
              <React.Fragment>
                <Tag color="blue">{<FormattedNumber value={product.price} />} THB</Tag>
                {product.imageUrl && <img src={product.imageUrl} alt={product.name.en} style={{ maxWidth: 100, maxHeight: 100, margin: 12 }}/>}
              </React.Fragment>
            }
          >
            <List.Item.Meta
              avatar={<Avatar src={product.imageUrl} />}
              title={
                <span style={{ whiteSpace: 'pre-line' }}>{localeGet(product, 'name', locale)}</span>
              }
              description={localeGet(product, 'description', locale)}
            />
          </List.Item>
        }
        }
      />
    </div>
  }
}

export default ProductExtraSale



// WEBPACK FOOTER //
// ./src/App/components/ProductExtraSale/ProductExtraSale.js